import { MapPinIcon } from '@heroicons/react/24/outline'
import { ReactNode, useMemo } from 'react'
import { Customer } from '../../../gql/graphql'
import { formatDateRange } from '../../_helpers/formatDateRange'
import { FestivalImage } from '../FestivalImage'
import { FestivalLogo } from '../FestivalLogo'

type PropTypes = {
  festival: Customer
  actions: ReactNode
}

export const FestivalCard = ({ festival, actions }: PropTypes) => {
  const dateRange = useMemo(() => formatDateRange(festival.begin, festival.end), [festival.begin, festival.end])

  return (
    <article className={'group flex flex-col overflow-hidden rounded-3xl bg-white border border-sand-200 shadow-sm transition-shadow duration-300 hover:shadow-lg'}>
      <FestivalImage
        imageUrl={festival.heroImageUrl}
        title={festival.title}
        className={'h-44'}
      >
        {festival.logoUrl && (
          <FestivalLogo
            logoUrl={festival.logoUrl}
            background={festival.logoBackground}
            className={'absolute bottom-3 left-4 h-12 w-auto max-w-40 rounded-2xl p-2.5'}
          />
        )}
      </FestivalImage>

      <div className={'flex flex-1 flex-col p-5'}>
        <h3 className={'text-xl font-bold tracking-tight text-primary-200 text-balance'}>
          {festival.title}
        </h3>
        {dateRange && (
          <p className={'mt-1 text-sm font-semibold text-gold-200'}>
            {dateRange}
          </p>
        )}
        {festival.location && (
          <p className={'mt-1 flex items-center gap-1 text-sm text-gray-600'}>
            <MapPinIcon className={'h-4 w-4 shrink-0'} />
            {festival.location}
          </p>
        )}
        {festival.teaser && (
          <p className={'mt-3 text-sm leading-6 text-gray-600'}>
            {festival.teaser}
          </p>
        )}
        <div className={'mt-auto flex flex-wrap items-center gap-3 pt-5'}>
          {actions}
        </div>
      </div>
    </article>
  )
}
